var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-sm btn-danger",staticStyle:{"font-size":"80%","margin-bottom":"1em","display":"block"},attrs:{"target":"_blank","href":_vm.poucenieLink}},[_vm._v("\n  "+_vm._s(_vm.$t('message.butPoucenie'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }